import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, sanitizePathForAnalytics } from '../services/analytics';

export function RouteTracker(): null {
  const location = useLocation();

  useEffect(() => {
    // Only send the sanitized pathname - never query strings which may contain
    // tokens, OTP codes, or other sensitive values.
    trackPageView(sanitizePathForAnalytics(location.pathname));
  }, [location]);

  return null;
}
